"use strict";
// greg hedin
Object.defineProperty(exports, "__esModule", { value: true });
var Clipboard = /** @class */ (function () {
    function Clipboard() {
    }
    Clipboard.init = function () {
        window.addEventListener('copy', function (e) {
            if (Clipboard._data) {
                e.clipboardData.setData('text/plain', Clipboard._data);
                e.preventDefault(); // this disables 'ctrl + c'
                Clipboard._data = null;
            }
        });
    };
    Clipboard._data = null;
    // MSIE boolean
    Clipboard.POS = !!window['clipboardData'];
    Clipboard.copy = function (data) {
        Clipboard._data = data;
        if (!Clipboard.POS) {
            document.execCommand('copy');
        }
        //  POS browsers
        else if (!!window['clipboardData']) {
            window['clipboardData'].setData('Text', Clipboard._data);
            Clipboard._data = null;
        }
    };
    return Clipboard;
}());
exports.Clipboard = Clipboard;
Clipboard.init();
//# sourceMappingURL=ts-clipboard.js.map